import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApplicationId } from '@nx-customer-apps/components';
import { RoomByRoomApiService } from './services';

export function createRoomByRoomService(config: ApiPlanningProjectsConfig, http: HttpClient) {
    return new RoomByRoomApiService(config, http);
}

export const API_PLANNING_PROJECTS_CONFIG = new InjectionToken<string>('API_PLANNING_PROJECTS_CONFIG');

export interface ApiPlanningProjectsConfig {
    apiBaseUrl: string;
    applicationId: ApplicationId;
}
